const trimTrailingSlash = (value: string): string => value.replace(/\/+$/, "");

const normalizeEnvUrl = (value?: string): string => {
  if (!value) {
    return "";
  }
  return value.replace(/[`'"\s]/g, "");
};

const getPublicBaseUrl = (): string =>
  trimTrailingSlash(normalizeEnvUrl(process.env.NEXT_PUBLIC_API_BASE_URL));

export const getApiBaseUrl = (): string => getPublicBaseUrl();

export const buildApiUrl = (path: string, baseUrl = getApiBaseUrl()): string => {
  if (/^[a-z][a-z0-9+.-]*:/i.test(path) || /^\/\//.test(path)) {
    return path;
  }
  return `${trimTrailingSlash(baseUrl)}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildPublicApiUrl = (path: string): string => buildApiUrl(path, getApiBaseUrl());
